import { render, staticRenderFns } from "./AlertBadge.vue?vue&type=template&id=31ee1b2e&lang=pug"
import script from "./AlertBadge.vue?vue&type=script&lang=js"
export * from "./AlertBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports